module.exports = __webpack_public_path__ + "img/gml_5_splash.0a84dcbe.jpg";